module.exports = __webpack_public_path__ + "img/der_04_xrobot.785e1411.gif";